<template>
  <v-container fluid class="pa-0 ma-0">
    <div class="px-0 py-0 ma-0 mb-4 d-flex justify-space-between">
      <div class="d-flex align-start flex-grow-1">
        <ImageMedia
          class="print-header__logo"
          data-testId="print-header-logo"
          style="max-width:120px; max-height:60px"
          :src="logoMediaObject"
          :defaultImage="Logo"
        />
        <span
          class="body-2 mb-2 d-flex align-center blue-grey--text text--darken-3 font-weight-bold ml-4"
        >
          {{ rev.name }}

          <v-icon
            v-if="isImplemented && !isValidated"
            class="ml-2"
            color="green"
            size="16"
            >mdi-rocket-launch
          </v-icon>

          <v-icon v-if="isValidated" class="ml-2" color="green" size="16"
            >mdi-check-decagram
          </v-icon>
        </span>
      </div>

      <div class="px-0 d-flex flex-column" style="min-width:200px">
        <div v-if="rev.status" class="d-flex align-center justify-end">
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('problem_solving.print.status') }}:
            <span class="font-weight-medium">{{ revStatus }}</span>
          </p>
        </div>
        <div v-if="rev.createdAt" class="d-flex align-center justify-end">
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('problem_solving.print.creation_date') }}:
            <span class="font-weight-medium">{{
              humanDate(rev.createdAt)
            }}</span>
          </p>
        </div>
        <div v-if="rev.completedAt" class="d-flex justify-end align-center">
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('problem_solving.print.completion_date') }}:
            <span class="font-weight-medium">{{
              humanDate(rev.completedAt)
            }}</span>
          </p>
        </div>
        <div
          v-if="isImplemented && !isValidated"
          class="d-flex align-center justify-end"
        >
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('rev.validation.implementation_date') }}:
            <span class="font-weight-medium">{{
              humanDate(implementationAt)
            }}</span>
          </p>
        </div>
        <div v-if="isValidated" class="d-flex align-center justify-end">
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('rev.validation.validation_date') }}:
            <span class="font-weight-medium">{{
              humanDate(validationAt)
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <v-divider class="theme--print" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import Logo from '@/assets/images/logo-rever.png'
import { utils } from 'frontend-js-shared'
import revMixin from '@/mixins/revMixin.vue'
import _ from 'lodash'

export default {
  name: 'HeaderPrint',

  components: {
    ImageMedia,
  },

  mixins: [revMixin],

  props: {
    rev: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      Logo,
    }
  },

  computed: {
    ...mapState({
      logoMediaObject: state => state.access.logoMediaObject,
    }),

    revStatus() {
      return this.$t(
        `problem_solving.print.statusText.${_.snakeCase(this.rev.status)}`
      )
    },

    isImplemented() {
      return this.isRevValidated(this.rev)
    },

    implementationAt() {
      return (
        this.rev?.validations__implementation__validatedAt ??
        this.rev?.validations?.implementation?.validatedAt
      )
    },

    isValidated() {
      return this.isFinanciallyValidated(this.rev)
    },

    validationAt() {
      return (
        this.rev?.validations__financial__validatedAt ??
        this.rev?.validations?.financial?.createdAt
      )
    },
  },

  methods: {
    humanDate(date) {
      return utils.dates.humanDate(date)
    },
  },
}
</script>
